module.exports = __webpack_public_path__ + "img/img2.534f4a8e.png";